import React, { useState, useEffect } from 'react';
import { supabase } from '../../api/supabase';

export default function BranchSelectModal({ defaultBranchId, onConfirm, onCancel }) {
  const [branches, setBranches] = useState([]);
  const [selected, setSelected] = useState(defaultBranchId || '');

  useEffect(() => {
    supabase.from('branches').select('id, name, code').eq('is_active', true).order('name')
      .then(({ data }) => {
        setBranches(data || []);
        if (!selected && data?.length) setSelected(defaultBranchId || data[0].id);
      });
  }, []);

  useEffect(() => {
    if (defaultBranchId && !selected) setSelected(defaultBranchId);
  }, [defaultBranchId]);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: 'var(--surface, #fff)', borderRadius: 14, padding: '36px 40px',
        minWidth: 320, boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
        display: 'flex', flexDirection: 'column', gap: 20, alignItems: 'center',
      }}>
        <div style={{ fontWeight: 700, fontSize: 18 }}>Select Branch</div>
        <div style={{ fontSize: 13, color: 'var(--text-muted)', textAlign: 'center' }}>
          Which branch is this transaction for?
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%' }}>
          {branches.map(b => (
            <button
              key={b.id}
              onClick={() => setSelected(b.id)}
              style={{
                padding: '12px 20px', borderRadius: 8, border: '2px solid',
                borderColor: selected === b.id ? 'var(--primary, #e67e22)' : 'var(--border, #e5e7eb)',
                background: selected === b.id ? 'rgba(230,126,34,0.08)' : 'transparent',
                fontWeight: selected === b.id ? 700 : 400,
                fontSize: 15, cursor: 'pointer', textAlign: 'left',
                color: 'var(--text)',
              }}
            >
              {b.name}
            </button>
          ))}
        </div>
        <button
          className="btn btn-primary"
          style={{ width: '100%', padding: '11px 0', fontSize: 15, textAlign: 'center', justifyContent: 'center' }}
          disabled={!selected}
          onClick={() => onConfirm(selected)}
        >
          Continue
        </button>
        {onCancel && (
          <button
            onClick={onCancel}
            style={{ background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: 13, cursor: 'pointer', padding: '4px 0' }}
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  );
}
